'use client';

import Image from 'next/image';
import { useIsTabletOrDesktop } from 'app/hooks/useMediaQuery';

import { IBranchBenefitPreview } from 'app/interfaces/branches';
import AnswerCardMobile from './AnswerCardMobile';
import { defaultProcessText } from 'app/utility/textProcessing';

export default function AnswerCard({
  title,
  description,
  image
}: IBranchBenefitPreview) {
  // Хук гидрационно-безопасен (false до монтирования), поэтому отдельный
  // isMounted-гейт больше не нужен: сервер и первый клиентский рендер совпадают.
  const isTabletOrDesktop = useIsTabletOrDesktop();

  return isTabletOrDesktop ? (
    <div className="group flex flex-col justify-between gap-4 md:gap-8 xl:gap-14 p-5 md:py-8 bg-graphite-dark rounded-xl">
      <h3
        className="text-h1 xl:text-p1 uppercase xl:normal-case mb-auto"
        dangerouslySetInnerHTML={{
          __html: defaultProcessText(title as string)
        }}
      />
      <div
        className="hidden md:block xl:mb-9 text-p3 xl:text-p2 xl:opacity-0 xl:group-hover:opacity-100 xl:translate-y-4 xl:group-hover:translate-y-0 duration-700 transition-transform"
        dangerouslySetInnerHTML={{
          __html: defaultProcessText(description as string)
        }}
      />
      {!!image && (
        <Image
          src={image.url}
          alt={image.alt ?? ''}
          width={67}
          height={32}
          className="xl:opacity-50 xl:group-hover:opacity-100 transition-opacity duration-700"
        />
      )}
    </div>
  ) : (
    <AnswerCardMobile title={title} description={description} image={image} />
  );
}
